import React from 'react'
import { styled } from '@mui/material/styles'
import { Box, IconButton } from '@mui/material'
import {
  Close as CloseIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
} from '@mui/icons-material'
import { AlertType } from './types/AlertType'
import ThemeConfig from '../../theme/ThemeConfig'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'

const PREFIX = 'Header'

const classes = {
  container: `${PREFIX}-container`,
  headerText: `${PREFIX}-headerText`,
}

const StyledBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'alertType',
})<HeaderProps>(({ theme, alertType }) => ({
  [`&.${classes.container}`]: {
    backgroundColor:
      alertType === AlertType.Warning
        ? ThemeConfig.palette.warning.main
        : ThemeConfig.palette.error.main,
    height: '36px',
    padding: theme.spacing(0, 1),
  },

  [`& .${classes.headerText}`]: {
    color:
      alertType === AlertType.Warning
        ? '#000000'
        : ThemeConfig.palette.primary.contrastText,
  },
}))

export interface HeaderProps {
  alertType: AlertType
  productCount?: number
  onClose?(): void
}

export const Header = ({
  alertType,
  productCount: passedProductCount,
  onClose = () => {},
}: HeaderProps) => {
  const productCount =
    (passedProductCount ?? -1) >= 0 ? passedProductCount : null

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={ThemeConfig}>
        <StyledBox
          display="flex"
          alignItems="center"
          flexWrap="nowrap"
          className={classes.container}
          alertType={alertType}
        >
          <Box flexShrink={1} className={classes.headerText} pr={1} pt={0.25}>
            {alertType === AlertType.Error && <ErrorIcon />}
            {alertType === AlertType.Warning && <WarningIcon />}
          </Box>
          <Box flexGrow={1} className={classes.headerText}>
            <h3>
              {productCount !== null && (
                <>
                  {productCount! > 0 && `${productCount} `}
                  Product{productCount! > 1 ? 's' : ''} with
                </>
              )}
              {productCount === null && 'Product'}
              {alertType === AlertType.Warning && ' Warnings'}
              {alertType === AlertType.Error && ' Errors'}
            </h3>
          </Box>
          <Box flexShrink={1}>
            <IconButton
              aria-label="Close"
              type="submit"
              size="small"
              className={classes.headerText}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </StyledBox>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
